import React from "react";
import { CalendarBaseWrapper } from "./Styles";
import { Calendar } from "@fluentui/react-calendar-compat";
import type { CalendarProps } from "@fluentui/react-calendar-compat";
import { useTranslation } from "react-i18next";

const CalendarCustom = (props: CalendarProps) => {
  const { t } = useTranslation();
  const dayPickerStrings = {
    months: [
      t("January"),
      t("February"),
      t("March"),
      t("April"),
      t("May"),
      t("June"),
      t("July"),
      t("August"),
      t("September"),
      t("October"),
      t("November"),
      t("December"),
    ],
    shortMonths: [
      t("Jan"),
      t("Feb"),
      t("Mar"),
      t("Apr"),
      t("May"),
      t("Jun"),
      t("Jul"),
      t("Aug"),
      t("Sep"),
      t("Oct"),
      t("Nov"),
      t("Dec"),
    ],
    days: [
      t("Sunday"),
      t("Monday"),
      t("Tuesday"),
      t("Wednesday"),
      t("Thursday"),
      t("Friday"),
      t("Saturday"),
    ],
    shortDays: [t("S"), t("M"), t("T"), t("W"), t("T"), t("F"), t("S")],
    goToToday: t("Today"),
    prevMonthAriaLabel: t("Previous month"),
    nextMonthAriaLabel: t("Next month"),
    prevYearAriaLabel: t("Previous year"),
    nextYearAriaLabel: t("Next year"),
    closeButtonAriaLabel: t("Close"),
    isRequiredErrorMessage: t("Field is required."),
    invalidInputErrorMessage: t("Invalid date format."),
  };

  return (
    <CalendarBaseWrapper className="CalendarBaseWrapper">
      <Calendar {...props} strings={dayPickerStrings}/>
    </CalendarBaseWrapper>
  );
};

export default CalendarCustom;
